import { Component, Input } from '@angular/core';
import { ApiImpact } from '@tytapp/api';

@Component({
    selector: 'tyt-company-impact-item',
    templateUrl: './company-impact-item.component.html',
    styleUrls: ['./company-impact-item.component.scss']
})
export class CompanyImpactItemComponent {

    @Input()
    impact: ApiImpact;

    @Input()
    showLearnMore: boolean = true;

    constructor() { }

    get impactTopic(): string {
        return this.impact?.topics?.[0]?.name;
    }

    get topicLink(): string {
        return `/topics/${this.impact?.topics?.[0]?.slug}`;
    }

}
